import { createAction } from '@reduxjs/toolkit';
import { AllFlagsDataFilters } from '../interfaces/MyPeopleEvalsDataFilters';
import { StartEvalData } from '@modules/EvaluationModule/interfaces/StartEvalData';

export const getMyPeopleEvalData = createAction<AllFlagsDataFilters>('myPeopleEvalPage/getMyPeopleEvalData');
export const setMyPeopleEvalDataLoading = createAction<void>('myPeopleEvalPage/setMyPeopleEvalDataLoading');
export const setSelectedEvalsAction = createAction<StartEvalData>('myPeopleEvalPage/setSelectedEvalsAction');
